import React, { useCallback, useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";

const debounce = (func, wait) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, wait);
  };
};

function InputAutoComplet({
  setValue,
  inputValue,
  InputList = [],
  displayDetailsHandler,
  APICall,
  placeholder = "Input",
  diaplayDropdown,
  resetVal,
  disabled = false,
  activeFlag = false,
  onFocusHandle = () => {},
  idx,
}) {
  const batchDebounce = useCallback(debounce(APICall, 600), []);
  return (
    <>
      <Autocomplete
        key={resetVal}
        inputValue={inputValue[idx].medicine_batch}
        disablePortal
        disabled={disabled}
        clearOnBlur={false}
        options={InputList}
        clearOnEscape={true}
        // filterOptions={filterPerfect ? (options) => options.filter(opt => opt['batch'] !== '') : undefined}
        componentsProps={{
          paper: {
            sx: {
              width: "max-content",
            },
          },
        }}
        className="enter-details-input-autocomplete enter-details-batch-input"
        sx={{
          backgroundColor: "#FFF",
          width: "100%",
          height: "2rem",
          textTransform: "uppercase",
          "& .css-1krl8tb-MuiFormControl-root-MuiTextField-root": {
            height: "1.75em",
          },
          "& .MuiAutocomplete-hasPopupIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root":
            {
              height: "1.75em",
            },
          "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
            fontWeight: "600",
            top: "-8px",
            fontSize: "0.65em",
          },
          "& .MuiOutlinedInput-root": {
            height: "1.75em",
          },
          "& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator":
            {
              display: "none",
            },
          "& .MuiAutocomplete-input": {
            position: "absolute",
            width: "80% !important",
          },
          '&[data-focus="false"]': {
            backgroundColor: "transparent",
            borderColor: "transparent",
          },
          '&[aria-selected="false"]': {
            borderColor: "transparent",
          },
          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .Mui-disabled": {
            color: "#333 !important",
            "-webkit-text-fill-color": "unset !important",
            cursor: "not-allowed",
          },
        }}
        getOptionLabel={(option) => option.batch_number}
        required={true}
        renderOption={(props, InputList) => (
          <Box
            key={`${InputList[diaplayDropdown[0]]} | ${InputList[diaplayDropdown[1]]} | ${InputList[diaplayDropdown[2]]}`}
            component="li"
            sx={{
              "& > img": { mr: 2, flexShrink: 0, zIndex: "1000000 !important" },
              zIndex: "100000 !important",
              backgroundColor: InputList["backgroundFlag"]
                ? "#ACE1AF !important"
                : "",
            }}
            {...props}
            style={{ overflow: "visible" }}>
                {/* {InputList['batch_number']} */}
            {InputList[diaplayDropdown[0]]} | {InputList[diaplayDropdown[1]]} | {InputList[diaplayDropdown[2]]}
          </Box>
        )}
        onChange={(event, value) => {
          displayDetailsHandler(event, value, idx);
        }}
        onInputChange={(e, val) => {
          setValue((current) =>
            current.map((value_x, index) =>
              index === idx
                ? {
                    ...value_x,
                    medicine_batch: val,
                  }
                : value_x
            )
          );
          if (val === null || val === "") {
            return;
          }
          batchDebounce(e, val, idx);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            placeholder={placeholder}
            onFocus={(e) => batchDebounce(e, inputValue[idx].medicine_batch, idx)}
            style={{
              borderRadius: "0.30388rem",
              border: activeFlag
                ? "0.158px solid #186DAA"
                : "0.165px solid #ABABAB",
              background: "#FFF",
              boxShadow:
                "0px 3.374082088470459px 8.420619010925293px 0px rgba(169, 180, 203, 0.15)",
              readOnly: true,
            }}
          />
        )}
      />
    </>
  );
}

export default InputAutoComplet;
